<template>
  <div class="fig pie_fig">
        <div v-if="empty" :style="{ width: fig_data.width, height: fig_data.height }">
            <el-empty description="No data"></el-empty>
        </div>
        <div v-else :id="random_id" :style="{ width: fig_data.width, height: fig_data.height }"></div>
        <el-dialog
            title=""
            :visible.sync="fullFlag"
            width="90%"
            top='5vh'
            ref='dialog'
            >
            <div :id="full_random_id" :style="{ width: screenWidth*0.85+'px', height: screenHeight*0.75+'px' }"></div>
        </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
} from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

import {uuid,full_icons} from "@/bus.js";

echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
  ToolboxComponent
]);


export default {
  name: 'pie',
  props: ["fig_data", "loading","empty"],
  data: function () {
    return {
      random_id:'y',
      // loading: true,
      // fig_data:{
      //     width: "400px",
      //     height: "400px",
      //     plot_data:{
      //         data:[],
      //         val_col:'',
      //         cate_col:'',
      //         detail_cols:[],
      //         title:'',
      //     }
      // },
      myChart: null,
      fullFlag:false,
      full_random_id:'y',
      fullChart:null,
      screenHeight:document.documentElement.clientHeight,
      screenWidth:document.documentElement.clientWidth,
      full_icon:full_icons['expand'],
      mini_icon:full_icons['mini']
    }
  },
    created:function(){
        this.random_id=uuid();
        this.full_random_id=uuid();
        // setTimeout(this.full_random_id=uuid(), 100);
    },
    mounted: function () {
        this.$refs.dialog.rendered=true
        this.myChart = echarts.init(document.getElementById(this.random_id));
        this.myChart.showLoading();
        var _this = this
        window.onresize = function () {
            _this.screenWidth = document.documentElement.clientWidth
            _this.screenHeight = document.documentElement.clientHeight
            if(_this.myChart!==null){
              _this.myChart.resize();
            }
            if(_this.fullChart!==null){
              _this.fullChart.resize();
            }
        }
    },

    watch: {
        loading: function () {
            this.myChart.dispose();
            this.myChart = echarts.init(document.getElementById(this.random_id));
            if (this.loading) {
                this.myChart.showLoading();
            }
            else {
                this.plot(this.fig_data.plot_data,this.myChart,this.full_icon)
            }
        }
    },
  methods: {
    plot(plot_data,chart,full_icon) {
      var fig_title = plot_data.title
      var rawData = plot_data.data
      var option = {
        textStyle:{fontFamily :"Arial",color:'#000000'},
        title: {
          text: fig_title,
          subtext: '',
          left: 'center',
          textStyle:{fontFamily :"Arial",fontSize : 16},
        },
        tooltip: {
          trigger: 'item',
          show: true
        },
        // legend: {
        //     orient: 'horizontal',
        //   top:'top'
        // },
        // grid: {
        //   left: '70%',
        //   right: '5%',
        //   bottom: '10%'
        // },
        toolbox: {
          show: true,
          showTitle: false,
          feature: {
            restore: {},
            saveAsImage: {},
            myFull: {
                show: true,
                title: 'Full screen',
                icon: full_icon,
                onclick: (e) => {
                    this.showFullScreen(e.getOption())
                },
            }
          }
        },
        series: [
          {
            name: fig_title,
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: rawData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}\n ({d}%)'
            },
          }
        ]
      };
      chart.setOption(option);
    },
    showFullScreen() {
        if (this.fullFlag) {
            this.fullFlag = false
        } else {
            this.fullFlag = true
            if(this.fullChart!=null){
                this.fullChart.dispose();
            }
            this.fullChart = echarts.init(document.getElementById(this.full_random_id));
            this.plot(this.fig_data.plot_data,this.fullChart,this.mini_icon)
        }
    }
  }
}
</script>



<style>
.el-collapse-item__header {
  font-size: 16px;
  font-weight: 600;
}

</style>


// WEBPACK FOOTER //
// src/components/plot/pie.vue